// React and Redux
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Libs
import { ButtonSpocket } from "shared_components";
import { Col, Row } from "react-bootstrap";
import { browserHistory } from "react-router";
import { IntercomAPI } from "react-intercom";

// Components
import ModalWrapper from "../../ModalWrapper";

// Icons
import packageIcon from "../../../../assets/package-icon.svg";
import chartIcon from "../../../../assets/chart-icon.svg";
import badgeIcon from "../../../../assets/badge-icon.svg";
import moneyPaperIcon from "../../../../assets/money-paper-icon.svg";
// import expertStoreIcon from "../../../../assets/expert-store-icon.svg";
import chatCallIcon from "../../../../assets/chat-call-icon.svg";
import rocketSpocketIcon from "../../../../assets/rocket-spocket-icon.svg";

// Actions
import { closeModal } from "../../../../actions/ui";

// Style
import "./style.css";

class UpgradePlanModal extends Component {
  componentDidMount() {
    IntercomAPI("trackEvent", "Paywall");
  }
  render() {
    return (
      <ModalWrapper size="large Upgrade_Plan_Modal__body">
        <ModalWrapper.Header />
        <ModalWrapper.Body>
          <Row>
            <Col className="Upgrade_Plan_Modal__body_left" md={5} sm={12}>
              <img src={rocketSpocketIcon} alt="" />
            </Col>
            <Col md={7} sm={12} className="Upgrade_Plan_Modal__body_right">
              <Row>
                <Col className="Upgrade_Plan_Modal__title" md={12}>
                  Level up your business today
                </Col>
              </Row>
              <Row>
                <Col className="Upgrade_Plan_Modal__subtitle" md={12}>
                  Unlock powerful features that help you run your store{" "}
                  <span>like a pro</span>.
                </Col>
              </Row>
              <Row className="Upgrade_Plan_Modal__feature_list">
                <Col
                  md={6}
                  sm={12}
                  className="Upgrade_Plan_Modal__feature_item"
                >
                  <div className="Upgrade_Plan_Modal__feature_icon">
                    <img src={packageIcon} alt="" />
                  </div>
                  Unlimited Products
                </Col>
                <Col
                  md={6}
                  sm={12}
                  className="Upgrade_Plan_Modal__feature_item"
                >
                  <div className="Upgrade_Plan_Modal__feature_icon">
                    <img src={chartIcon} alt="" />
                  </div>
                  Unlimited Orders
                </Col>
              </Row>
              <Row className="Upgrade_Plan_Modal__feature_list">
                <Col
                  md={6}
                  sm={12}
                  className="Upgrade_Plan_Modal__feature_item"
                >
                  <div className="Upgrade_Plan_Modal__feature_icon">
                    <img src={moneyPaperIcon} alt="" />
                  </div>
                  Branded Invoicing
                </Col>
                <Col
                  md={6}
                  sm={12}
                  className="Upgrade_Plan_Modal__feature_item"
                >
                  <div className="Upgrade_Plan_Modal__feature_icon">
                    <img src={badgeIcon} alt="" />
                  </div>
                  Premium Products
                </Col>
              </Row>
              <Row className="Upgrade_Plan_Modal__feature_list">
                <Col
                  md={6}
                  sm={12}
                  className="Upgrade_Plan_Modal__feature_item"
                >
                  <div className="Upgrade_Plan_Modal__feature_icon">
                    <img src={chatCallIcon} alt="" />
                  </div>
                  Chat & Call Support
                </Col>
                {/* <Col
                  md={6}
                  sm={12}
                  className="Upgrade_Plan_Modal__feature_item"
                >
                  <div className="Upgrade_Plan_Modal__feature_icon">
                    <img src={expertStoreIcon} alt="" />
                  </div>
                  Expert Store Review
                </Col> */}
              </Row>
              <Row className="Upgrade_Plan_Modal__feature_list">
                <Col md={12} className="Upgrade_Plan_Modal__button">
                  <ButtonSpocket
                    bsSize="lg"
                    bsStyle="primary"
                    customButton={{
                      height: "55px",
                      width: "100%",
                      borderRadius: "3px",
                      fontSize: "18px",
                      fontWeight: "bold"
                    }}
                    onClick={() => {
                      browserHistory.push("/settings/plan");
                      this.props.closeModal();
                    }}
                  >
                    Start now for free
                  </ButtonSpocket>
                </Col>
              </Row>
            </Col>
          </Row>
        </ModalWrapper.Body>
      </ModalWrapper>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeModal }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps
)(UpgradePlanModal);



// WEBPACK FOOTER //
// ./src/components/_Shared/Modals/UpgradePlanModal/index.js